var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoveMemberIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Union",
    d: "M1.33333 5.33333C0.966667 5.33333 0.652667 5.20267 0.391333 4.94133C0.130444 4.68044 0 4.36667 0 4V1.33333C0 0.966667 0.130444 0.652667 0.391333 0.391333C0.652667 0.130444 0.966667 0 1.33333 0H10.6667C11.0333 0 11.3473 0.130444 11.6087 0.391333C11.8696 0.652667 12 0.966667 12 1.33333V4C12 4.36667 11.8696 4.68044 11.6087 4.94133C11.3473 5.20267 11.0333 5.33333 10.6667 5.33333H1.33333ZM1.33333 4H10.6667V1.33333H1.33333V4ZM1.33333 12C0.966667 12 0.652667 11.8696 0.391333 11.6087C0.130444 11.3473 0 11.0333 0 10.6667V8C0 7.63333 0.130444 7.31933 0.391333 7.058C0.652667 6.79711 0.966667 6.66667 1.33333 6.66667H10.6667C11.0333 6.66667 11.3473 6.79711 11.6087 7.058C11.8696 7.31933 12 7.63333 12 8V10.6667C12 11.0333 11.8696 11.3473 11.6087 11.6087C11.3473 11.8696 11.0333 12 10.6667 12H1.33333ZM1.33333 10.6667H10.6667V8H1.33333V10.6667Z",
    fill: "#A5A5A5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoveMemberIcon);
export default __webpack_public_path__ + "static/media/moveMemberIcon.a1ecedfbaac87f412027e0b27f3d105c.svg";
export { ForwardRef as ReactComponent };